var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 256 256",
    style: {
      msTransform: "rotate(360deg)",
      WebkitTransform: "rotate(360deg)",
      transform: "rotate(360deg)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M212 84a24 24 0 1 0 24 24a24.1 24.1 0 0 0-24-24Zm0 40a16 16 0 1 1 16-16a16 16 0 0 1-16 16ZM68 108a24 24 0 1 0-24 24a24.1 24.1 0 0 0 24-24Zm-24 16a16 16 0 1 1 16-16a16 16 0 0 1-16 16Zm48-40a24 24 0 1 0-24-24a24.1 24.1 0 0 0 24 24Zm0-40a16 16 0 1 1-16 16a16 16 0 0 1 16-16Zm72 40a24 24 0 1 0-24-24a24.1 24.1 0 0 0 24 24Zm0-40a16 16 0 1 1-16 16a16 16 0 0 1 16-16Zm21.2 108.3a39 39 0 0 1-18.8-23.5a40 40 0 0 0-76.8 0a39 39 0 0 1-18.7 23.5A36 36 0 0 0 88 220a36.8 36.8 0 0 0 14-2.8a67.9 67.9 0 0 1 52 0a36.8 36.8 0 0 0 14 2.8a36 36 0 0 0 17.2-67.7ZM168 212a27.7 27.7 0 0 1-11-2.2a75.1 75.1 0 0 0-29-5.8a75.9 75.9 0 0 0-29.1 5.8A26.9 26.9 0 0 1 88 212a28 28 0 0 1-13.3-52.6a47.6 47.6 0 0 0 22.6-28.3a32 32 0 0 1 61.4 0a47.6 47.6 0 0 0 22.6 28.3A28 28 0 0 1 168 212Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.8f5751a695c28cc77ad0a8ff1b7faa3d.svg";
export { ForwardRef as ReactComponent };